import window from 'window-or-global';
import AtlassianEditorContent from '../bootstrap/atlassian-editor-content';

/**
 * Used to be called getEditorContentGlobalObject
 */
export const exportAjsRteContentAsGlobal = () => {
	// AJS.Rte is not automagically defined to allow separate bundles for each global variable.
	if (typeof window.AJS.Rte === 'undefined') {
		if (process.env.NODE_ENV !== 'production') {
			console.error('AJS.Rte is supposed to be defined');
		}
		return;
	}
	if (typeof window.AJS.Rte.Content === 'undefined') {
		window.AJS.Rte.Content = AtlassianEditorContent;
	}
};
